"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formBlock = void 0;
const formBlock = () => {
    const formTabs = document.querySelectorAll('.form-tab [data-form-tab]');
    if (typeof (formTabs) != 'undefined' && formTabs != null) {
        formTabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                formTabs.forEach((tab) => {
                    removeClass(tab, 'is-active');
                });
                document.querySelectorAll('.form-content[data-form-content]').forEach((tab) => {
                    removeClass(tab, 'is-active');
                });
                const target = e.target;
                addClass(target, 'is-active');
                addClass(document.querySelector(`.form-content[data-form-content="${target.dataset.formTab}"]`), 'is-active');
            });
        });
        const formTabMobile = document.querySelector('#form-tab-mobile-menu_select');
        if (typeof (formTabMobile) != 'undefined' && formTabMobile != null) {
            formTabMobile.addEventListener('change', (e) => {
                document.querySelectorAll('.form-content[data-form-content]').forEach((tab) => {
                    removeClass(tab, 'is-active');
                });
                const target = e.target;
                addClass(document.querySelector(`.form-content[data-form-content="${target.value}"]`), 'is-active');
            });
        }
        const addClass = (el, className) => el.classList.add(className);
        const removeClass = (el, className) => el.classList.remove(className);
    }
};
exports.formBlock = formBlock;
